const style = {
  "hljs-comment": {
    "color": "#7285b7"
  },
  "hljs-quote": {
    "color": "#7285b7"
  },
  "hljs-variable": {
    "color": "#9db6ff"
  },
  "hljs-template-variable": {
    "color": "#9db6ff"
  },
  "hljs-tag": {
    "color": "#ffffff"
  },
  "hljs-name": {
    "color": "#9e9bff"
  },
  "hljs-selector-id": {
    "color": "#b833fc"
  },
  "hljs-selector-class": {
    "color": "#3a61ce"
  },
  "hljs-regexp": {
    "color": "#2346a9"
  },
  "hljs-deletion": {
    "color": "#294caf"
  },
  "hljs-number": {
    "color": "#ffc58f"
  },
  "hljs-built_in": {
    "color": "#ffc58f"
  },
  "hljs-builtin-name": {
    "color": "#ffc58f"
  },
  "hljs-literal": {
    "color": "#ffc58f"
  },
  "hljs-type": {
    "color": "#ffc58f"
  },
  "hljs-params": {
    "color": "#ffc58f"
  },
  "hljs-meta": {
    "color": "#ffc58f"
  },
  "hljs-link": {
    "color": "#ffc58f"
  },
  "hljs-attribute": {
    "color": "#ffeead"
  },
  "hljs-string": {
    "color": "#5effb5"
  },
  "hljs-symbol": {
    "color": "#5effb5"
  },
  "hljs-bullet": {
    "color": "#5effb5"
  },
  "hljs-addition": {
    "color": "#5effb5"
  },
  "hljs-title": {
    "color": "#bbdaff"
  },
  "hljs-section": {
    "color": "#bbdaff"
  },
  "hljs-keyword": {
    "color": "#ebbbff"
  },
  "hljs-selector-tag": {
    "color": "#ebbbff"
  },
  "hljs": {
    "display": "block",
    "overflowX": "auto",
    "background": "#002451",
    "color": "white",
    "padding": "0.5em"
  },
  "hljs-emphasis": {
    "fontStyle": "italic"
  },
  "hljs-strong": {
    "fontWeight": "bold"
  }
};

export default style;
